import Page from './components/Page'
import { TEAMS_PAGE } from './pages'

export default {
  [TEAMS_PAGE]: {
    path: '/reports/inbox/teams',
    component: Page,
  },
}
